import { withRegexComparators } from './withRegexComparators';
import { withMultiSelectInputComparators } from './withMultiSelectInputComparators';
import { ComparatorsDropdownProps } from '../types';
import { ComparatorOption } from '../../../utils/comparators';

export const withFeatureFlaggedComparators = (
  comparators: ComparatorOption[],
  comparatorDropdownProps: ComparatorsDropdownProps,
  field?: string,
) => [
  ...comparators,
  ...withRegexComparators(comparatorDropdownProps, field),
  ...withMultiSelectInputComparators(comparatorDropdownProps, field),
];
